module.exports = __webpack_public_path__ + "img/qq.2098110f.png";